module.exports = __webpack_public_path__ + "images/morning_coffee/morning-coffee-report-header.jpg";